export default function() {
    $(document).ready(function () {
        $('.clear-input').click(function (event) {
            $(this).addClass('d-none');
            $(this).closest('.input-group').find('input').val('')
        })
    })
}
